/* Adapted from the user-validated Binaa 5.15.6 page/drawer position lock. */
(() => {
  const root=document.documentElement, body=document.body;
  const chromeIOS=/CriOS\//.test(navigator.userAgent);
  const keys=['position','top','left','width','overflow'];
  const drawerKeys=['position','top','bottom','height','max-height','transform','transition'];
  const save=(node,list)=>list.map(key=>[key,node.style.getPropertyValue(key),node.style.getPropertyPriority(key)]);
  const restore=(node,values)=>values?.forEach(([key,value,priority])=>value?node.style.setProperty(key,value,priority):node.style.removeProperty(key));
  let locked=false,pending=false,x=0,y=0,savedBody,savedDrawer,drawer,timer;
  let frozenPage=[];
  let menuHeader=null,menuHeaderStyles=null,headerPlaceholder=null;
  const headerKeys=['position','top','left','right','bottom','width','margin','transform','transition'];
  function pinMenuHeader(){
    const header=document.querySelector('.shopify-section-header');
    if(!header||menuHeader)return;
    const rect=header.getBoundingClientRect();
    menuHeader=header;menuHeaderStyles=save(header,headerKeys);
    headerPlaceholder=document.createElement('div');
    headerPlaceholder.setAttribute('aria-hidden','true');
    headerPlaceholder.style.height=`${header.offsetHeight}px`;
    headerPlaceholder.style.flexShrink='0';
    header.before(headerPlaceholder);
    Object.entries({position:'fixed',top:`${Math.max(0,rect.top)}px`,left:`${rect.left}px`,right:'auto',bottom:'auto',width:`${rect.width}px`,margin:'0',transform:'none',transition:'none'}).forEach(([key,value])=>header.style.setProperty(key,value,'important'));
  }
  function unpinMenuHeader(){
    if(!menuHeader)return;
    restore(menuHeader,menuHeaderStyles);headerPlaceholder?.remove();
    menuHeader=null;menuHeaderStyles=null;headerPlaceholder=null;
  }
  const frameKeys=['position','top','left','right','bottom','width','height','min-height','max-height','margin','box-sizing','transform','transition'];
  function measurePage(){
    return Array.from(document.querySelectorAll('#MainContent,.section-announcement,.shopify-section-header,.shopify-section-group-footer-group,.qeydo-global-contact,.qeydo-sticky-cart,.scroll-top')).map(node=>({node,rect:node.getBoundingClientRect(),layout:(()=>{const style=getComputedStyle(node);return Object.fromEntries(['position','marginTop','marginBottom','marginLeft','marginRight','gridArea','alignSelf','order'].map(key=>[key,style[key]]));})()})).filter(({node,rect})=>rect.width>0&&rect.height>0&&(node.id==='MainContent'||(rect.bottom>0&&rect.top<window.innerHeight)));
  }
  function freezePage(frames){
    // Keep each flow box in place: removing MainContent from flow would pull
    // the footer up over the outgoing page before the next document arrives.
    frozenPage=frames.map(({node,rect,layout})=>{
      const values=save(node,frameKeys);
      let placeholder=null;
      if(layout.position!=='fixed'&&layout.position!=='absolute'){
        placeholder=document.createElement('div');
        placeholder.setAttribute('aria-hidden','true');
        placeholder.setAttribute('data-qeydo-navigation-space','');
        Object.entries({height:`${rect.height}px`,width:`${rect.width}px`,'box-sizing':'border-box','flex-shrink':'0',visibility:'hidden','pointer-events':'none','margin-top':layout.marginTop,'margin-bottom':layout.marginBottom,'margin-left':layout.marginLeft,'margin-right':layout.marginRight,'grid-area':layout.gridArea,'align-self':layout.alignSelf,'order':layout.order}).forEach(([key,value])=>placeholder.style.setProperty(key,value));
        node.before(placeholder);
      }
      Object.entries({position:'fixed',top:`${rect.top}px`,left:`${rect.left}px`,right:'auto',bottom:'auto',width:`${rect.width}px`,height:`${rect.height}px`,'min-height':'0','max-height':'none',margin:'0','box-sizing':'border-box',transform:'none',transition:'none'}).forEach(([key,value])=>node.style.setProperty(key,value,'important'));
      return {node,values,placeholder};
    });
  }
  const isOpen=()=>Boolean(document.querySelector('header-drawer details.menu-drawer-container[open]'));
  function lock(){
    if(locked)return;
    x=window.scrollX;y=window.scrollY;savedBody=save(body,keys);locked=true;
    if(isOpen())pinMenuHeader();
    body.style.setProperty('position','fixed','important');
    body.style.setProperty('top',`${-y}px`,'important');
    body.style.setProperty('left',`${-x}px`,'important');
    body.style.setProperty('width','100%','important');
    body.style.setProperty('overflow','hidden','important');
  }
  function unlock(){
    if(!locked)return;
    locked=false;unpinMenuHeader();restore(body,savedBody);savedBody=null;
    window.scrollTo({left:x,top:y,behavior:'instant'});
  }
  function reset(){
    pending=false;clearTimeout(timer);root.removeAttribute('data-qeydo-navigating');
    if(drawer){restore(drawer,savedDrawer);drawer.removeAttribute('data-qeydo-menu-frozen');drawer.removeAttribute('aria-busy');}
    savedDrawer=null;drawer=null;
    frozenPage.forEach(({node,values,placeholder})=>{restore(node,values);placeholder?.remove();});frozenPage=[];
    if(!isOpen())unlock();
  }
  function observe(){
    document.querySelectorAll('header-drawer details.menu-drawer-container').forEach(details=>{
      if(details.dataset.qeydoPositionReady)return;
      details.dataset.qeydoPositionReady='true';
      new MutationObserver(()=>{if(isOpen())lock();else if(!pending)unlock();}).observe(details,{attributes:true,attributeFilter:['open']});
    });
    if(isOpen())lock();
  }
  document.addEventListener('mousedown',event=>{
    if(event.button===0&&event.target.closest?.('header-drawer a[href]'))event.preventDefault();
  },true);
  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest?.('a[href]');
    if(!link||link.hasAttribute('download')||(link.target&&link.target!=='_self'))return;
    let url;try{url=new URL(link.href,location.href);}catch{return;}
    if(!/^https?:$/.test(url.protocol)||url.origin!==location.origin)return;
    if(url.pathname===location.pathname&&url.search===location.search)return;
    const menuLink=link.closest('header-drawer');
    // The proven drawer behavior applies on all browsers. Ordinary page links
    // use the position lock only in Chrome iOS, where the user reproduced the jump.
    if(!menuLink&&!chromeIOS)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(pending)return;
    drawer=menuLink?.querySelector('.menu-drawer')||null;
    const rect=drawer?.getBoundingClientRect();
    const pageFrames=!menuLink&&chromeIOS?measurePage():[];
    lock();pending=true;root.setAttribute('data-qeydo-navigating','');
    if(drawer&&rect){
      savedDrawer=save(drawer,drawerKeys);
      Object.entries({position:'fixed',top:`${rect.top}px`,bottom:'auto',height:`${rect.height}px`,'max-height':`${rect.height}px`,transform:'none',transition:'none'}).forEach(([key,value])=>drawer.style.setProperty(key,value,'important'));
      drawer.setAttribute('data-qeydo-menu-frozen','');drawer.setAttribute('aria-busy','true');
    }
    if(pageFrames.length)freezePage(pageFrames);
    timer=setTimeout(reset,12000);
    location.assign(url.href);
  },true);
  window.addEventListener('pageshow',reset);
  window.addEventListener('pagehide',()=>clearTimeout(timer));
  document.addEventListener('shopify:section:load',observe);
  observe();
})();
